// extracted by mini-css-extract-plugin
module.exports = {"scriptBlock":"CustomCodeBlock_scriptBlock__RSM7R"};